import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetAccreditationsQueryResponse, GetAccreditationsQueryParams, GetAccreditations403, GetAccreditations500 } from "../types/GetAccreditations";

export const getAccreditationsQueryKey = (params?: GetAccreditationsQueryParams) =>     [{url:`/api/accreditations`},...(params ? [params] : [])] as const;
      export function getAccreditationsQueryOptions <TData = GetAccreditationsQueryResponse, TError = GetAccreditations403 | GetAccreditations500>(params?: GetAccreditationsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getAccreditationsQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/accreditations`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Запрос на получение аккредитаций
 * @link /api/accreditations
 */

export function useGetAccreditations <TData = GetAccreditationsQueryResponse, TError = GetAccreditations403 | GetAccreditations500>(params?: GetAccreditationsQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getAccreditationsQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getAccreditationsQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
